import { Box, Typography } from "@mui/material";
import { omitBy, pick } from "lodash";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export default function AddressFormat({ address }) {
    const { t } = useTranslation()

    const addr = useMemo(() => {
        return address ? Object.keys(omitBy(pick(address, ["city", "area", "street", "houseNumber", "floor", "flat", "landmark"]), v => !Boolean(v))) : []
    }, [address])

    if (!address) {
        return <Box>-</Box>
    }

    return (
        <Box display="flex" alignItems="center" flexWrap="wrap">
            {addr.map((key) => (
                <Box display="flex" alignItems="center" flexWrap="nowrap" key={key} mr={1.5}>
                    <Typography variant="subtitle1" sx={{ fontWeight: "bold", mr: 1, whiteSpace:'nowrap' }}>{`${t(key)} : `}</Typography>
                    <Typography variant="subtitle2" color="text.lighter" sx={{wordWrap: "break-word", overflowWrap: "break-word", maxWidth:"90%"}}>{address[key]}</Typography>
                </Box>
            ))}
        </Box>
    )
}